import { useMemo } from 'react'
import { skipToken } from '@reduxjs/toolkit/query'
import { useListInvoicedocumentsQuery } from 'store/invoices/invoices.api'
import { ListDocumentsResponse } from 'store/invoices/invoices.types'
import { getLatestLoadConfirmationDocument } from 'utils/load-confirmation-documents'
import InvoiceDocumentsTable from 'pages/invoice/invoice-details/invoice-table/invoice-table-body/invoice-table-documents/invoice-documents-dialog/invoice-documents-table/invoice-documents-table.component'
import { CarrierLcSaveResult } from './use-send-to-carrier'

type CarrierEmailAttachmentsProps = {
  carrierContext: CarrierLcSaveResult
}

const CarrierEmailAttachments = ({ carrierContext }: CarrierEmailAttachmentsProps) => {
  const orderId = String(carrierContext.carrierOrderId)

  const { data: documents } = useListInvoicedocumentsQuery(
    carrierContext.carrierOrderId ? { orderId } : skipToken
  )

  const lcDocuments = useMemo((): ListDocumentsResponse => {
    const latestDocument = getLatestLoadConfirmationDocument(documents?.LC)

    if (latestDocument) {
      return { LC: [latestDocument] }
    }

    if (carrierContext.s3Path) {
      return {
        LC: [
          {
            documentName: `LC_${carrierContext.loadNumber}.pdf`,
            originalName: `LC_${carrierContext.loadNumber}.pdf`,
            s3Path: carrierContext.s3Path,
          },
        ],
      }
    }

    return { LC: [] }
  }, [carrierContext.loadNumber, carrierContext.s3Path, documents?.LC])

  if (!documents && !carrierContext.s3Path) {
    return <p>loading</p>
  }

  return (
    <InvoiceDocumentsTable
      documents={lcDocuments}
      orderId={orderId}
      invoiceId=""
      condensed
    />
  )
}

export default CarrierEmailAttachments
